import { render, staticRenderFns } from "./rankingIp.vue?vue&type=template&id=288df6d0&scoped=true&"
import script from "./rankingIp.vue?vue&type=script&lang=js&"
export * from "./rankingIp.vue?vue&type=script&lang=js&"
import style0 from "./rankingIp.vue?vue&type=style&index=0&id=288df6d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288df6d0",
  null
  
)

export default component.exports